import { Link } from "react-router-dom";
import { RichHtml } from "@/components/admin/RichHtml";
import { Button } from "@/components/ui/button";
import { hasIntro, listingCta } from "@/lib/listing";

// Renders the optional CMS-managed intro block (overline/heading/body + CTA).
// Renders nothing (no blank space) when there is no legitimate published content.
export function ListingIntro({ cfg }) {
  if (!hasIntro(cfg)) return null;
  const cta = listingCta(cfg);
  const overline = String(cfg.intro_overline || "").trim();
  const heading = String(cfg.intro_heading || "").trim();
  return (
    <div className="mb-10 max-w-3xl" data-testid="listing-intro">
      {overline && <div className="overline text-saffron" data-testid="listing-intro-overline">{overline}</div>}
      {heading && <h2 className="mt-2 font-display text-2xl font-semibold text-charcoal md:text-3xl" data-testid="listing-intro-heading">{heading}</h2>}
      <RichHtml html={cfg.intro_body} className="mt-3 text-base text-muted-foreground" testid="listing-intro-body" />
      {cta && (
        cta.href.startsWith("/") ? (
          <Link to={cta.href}><Button className="mt-4 rounded-full bg-saffron font-accent text-xs text-white hover:bg-saffron-dark" data-testid="listing-intro-cta">{cta.label}</Button></Link>
        ) : (
          <a href={cta.href} target="_blank" rel="noopener noreferrer"><Button className="mt-4 rounded-full bg-saffron font-accent text-xs text-white hover:bg-saffron-dark" data-testid="listing-intro-cta">{cta.label}</Button></a>
        )
      )}
    </div>
  );
}
